export const CREATING_MEDIA = "CREATING_MEDIA";
export const UPDATING_MEDIA = "UPDATING_MEDIA";
export const MEDIA_CREATED = "MEDIA_CREATED";
export const MEDIA_UPDATED = "MEDIA_UPDATED";
export const ERROR_MEDIA_CREATE = "ERROR_MEDIA_CREATE";
export const ERROR_MEDIA_UPDATE = "ERROR_MEDIA_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
